module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/core-js/library/modules/_redefine.js
// module id = 26
// module chunks = 0